/* eslint-disable react/no-multi-comp */

import React from 'react'

import { FormattedMessage } from 'react-intl'

export const SCROLL_STEP_HEIGHT = 30

export const ROUND_TITLE = (round, arena) => (
    <FormattedMessage
        id='postbattle_details.round.title'
        defaultMessage='{round} бой ({arena})'
        values={{ round, arena }}
    />
)

export const TECHNICAL = {
    VICTORY: (
        <FormattedMessage
            id='postbattle_details.round.technical.victory'
            defaultMessage='Противник не вышел в бой'
        />
    ),
    DEFEAT: (
        <FormattedMessage
            id='postbattle_details.round.technical.defeat'
            defaultMessage='Союзники не вышли в бой'
        />
    ),
}

export const POINTS_UNDER_CONTROL = [
    <FormattedMessage
        key='0-points'
        id='postbattle_details.series_result.0'
        defaultMessage='Цитадель союзников захвачена'
        description='0 точек под контролем союзников'
    />,
    <FormattedMessage
        key='1-point'
        id='postbattle_details.series_result.1'
        defaultMessage='Удержание Цитадели при потере обоих рубежей'
        description='1 точка под контролем союзников'
    />,
    <FormattedMessage
        key='2-points'
        id='postbattle_details.series_result.2'
        defaultMessage='Удержание запасного рубежа при потере передового'
        description='2 точки под контролем союзников'
    />,
    <FormattedMessage
        key='3-points'
        id='postbattle_details.series_result.3'
        defaultMessage='Удержание обоих рубежей без захвата рубежей противника'
        description='3 точки под контролем союзников'
    />,
    <FormattedMessage
        key='4-points'
        id='postbattle_details.series_result.4'
        defaultMessage='Захват только передового рубежа'
        description='4 точки под контролем союзников'
    />,
    <FormattedMessage
        key='5-points'
        id='postbattle_details.series_result.5'
        defaultMessage='Захват обоих рубежей без захвата Цитадели'
        description='5 точек под контролем союзников'
    />,
    <FormattedMessage
        key='6-points'
        id='postbattle_details.series_result.6'
        defaultMessage='Захват Цитадели противника'
        description='6 точек под контролем союзников'
    />,
]

export const REWARDS = {
    first_victory_on_direction: (
        <FormattedMessage
            id='postbattle_details.rewards.first_victory_on_direction'
            defaultMessage='x2 за первую победу на плацдарме'
        />
    ),
    requisition: percent => (
        <FormattedMessage
            id='postbattle_details.rewards.requisition'
            defaultMessage='+ {percent}% за резерв «Реквизиция»'
            values={{ percent }}
        />
    ),
    legionary: (
        <FormattedMessage
            id='postbattle_details.rewards.legionary'
            defaultMessage='Награда легионерам'
        />
    ),
    clan_efficiency: (
        <FormattedMessage
            id='postbattle_details.rewards.clan_efficiency'
            defaultMessage='Эффективность отряда'
        />
    ),
    high_capacity_transport: percent => (
        <FormattedMessage
            id='postbattle_details.rewards.high_capacity_transport'
            defaultMessage='+ {percent}% за резерв «Большегрузный транспорт»'
            values={{ percent }}
        />
    ),
    airstrike: percent => (
        <FormattedMessage
            id='postbattle_details.rewards.airstrike'
            defaultMessage='+ {percent}% за резерв «Авиаудар»'
            values={{ percent }}
        />
    ),
    artillery_strike: percent => (
        <FormattedMessage
            id='postbattle_details.rewards.artillery_strike'
            defaultMessage='+ {percent}% за резерв «Артобстрел»'
            values={{ percent }}
        />
    ),
    inspiration: percent => (
        <FormattedMessage
            id='postbattle_details.rewards.inspiration'
            defaultMessage='+ {percent}% за резерв «Воодушевление»'
            values={{ percent }}
        />
    ),
}

export const BATTLE_REWARD = (
    <FormattedMessage
        id='postbattle_details.battle_reward'
        defaultMessage='Итого за бой'
    />
)

export const SERIES_REWARD = (
    <FormattedMessage
        id='postbattle_details.series_reward'
        defaultMessage='Итого за Наступление'
    />
)

export const TOTAL_REWARD = (
    <FormattedMessage
        id='postbattle_details.total_reward'
        defaultMessage='Итого'
    />
)



// WEBPACK FOOTER //
// ./containers/PostbattleScreen/components/Details/constants.jsx